<template>
  <Layout>
    <q-card class="flexbox">
      <div class="profile-header">
        <div class="profile-header-title">User Settings</div>
        <div class="profile-header-icons">
          <div>
            <q-icon
              name="fas fa-user"
              size="15px"
              :color="userTab === 'profile-form' ? 'primary' : 'grey-7'"
              @click="userTab = 'profile-form'"
              class="cursor-pointer"
            >
              <q-tooltip>Personal Information</q-tooltip>
            </q-icon>
          </div>
          <div>
            <q-icon
              name="fas fa-map-marker-alt"
              @click="userTab = 'profile-address'"
              size="15px"
              :color="userTab === 'profile-address' ? 'primary' : 'grey-7'"
              class="cursor-pointer"
            >
              <q-tooltip>Address</q-tooltip>
            </q-icon>
          </div>
          <!-- <div style="margin-left:5px">
            <q-icon
              name="fas fa-cubes"
              @click="userTab = 'profile-packages'"
              size="17px"
              :color="userTab === 'profile-packages' ? 'primary' : 'grey-7'"
              class="cursor-pointer"
            >
              <q-tooltip>Packages</q-tooltip>
            </q-icon>
          </div> -->
        </div>
      </div>
      <div class="profile-content">
        <transition appear name="component-fade" mode="out-in">
          <component :is="userTab"></component>
        </transition>
        <reset-password-form></reset-password-form>
      </div>
    </q-card>
  </Layout>
</template>

<script>
import axios from "../axios";
import Layout from "../components/Layout";
import ProfileForm from "../components/ProfileForm";
import ProfileAddress from "../components/ProfileAddress";
import ResetPasswordForm from "../components/ResetPasswordForm";
import ProfilePackages from "../components/ProfilePackages";
export default {
  components: {
    ProfileAddress,
    ProfilePackages,
    ResetPasswordForm,
    Layout,
    ProfileForm,
  },
  name: "profile",
  computed: {
    packages: {
      get() {
        return this.$store.state.pack.packages;
      },
      set(val) {
        this.$store.commit("pack/SET_PACKAGES", val);
      },
    },
    user() {
      return this.$store.state.profile.user;
    },
    userTab: {
      get() {
        return this.$store.state.profile.userTab;
      },
      set(val) {
        this.$store.commit("profile/SET_USER_TAB", val);
      },
    },
  },
  async mounted() {
    if (this.$store.state.pack.packages.length === 0) await this.getPackages();
  },
  methods: {
    async getPackages() {
      const { data } = await axios.get("packages");
      this.packages = data.data;
    },
  },
  metaInfo() {
    return {
      title: `Settings - FMS`,
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content: "",
        },
        {
          property: "og:title",
          content: "Settings - FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>
